import { useQuery } from '@tanstack/react-query';
import { Flex, Box, Heading, Text, Card, CardHeader, CardContent, LoadingOrbit } from '@chatsdet/ui';
import { API_URL } from '../../config.js';

type VersionResponse = {
  ok: boolean;
  version: string;
};

export function AboutTab() {
  const versionQuery = useQuery({
    queryKey: ['superadmin-version'],
    queryFn: async (): Promise<VersionResponse> => {
      const res = await fetch(`${API_URL}/superadmin/version`, {
        credentials: 'include',
      });
      if (!res.ok) {
        if (res.status === 403) {
          throw new Error('Access denied. Superadmin privileges required.');
        }
        throw new Error('Failed to fetch version');
      }
      return res.json();
    },
  });

  return (
    <Box className="space-y-6">
      <Card padding="lg">
        <CardHeader>
          <Heading level={3}>Application Info</Heading>
          <Text size="sm" className="text-muted-foreground mt-1">
            Version and build information for the deployed application.
          </Text>
        </CardHeader>
        <CardContent>
          {versionQuery.isLoading ? (
            <Flex align="center" justify="center" className="py-8">
              <LoadingOrbit size="lg" />
            </Flex>
          ) : versionQuery.isError ? (
            <Text className="text-destructive">
              {versionQuery.error instanceof Error
                ? versionQuery.error.message
                : 'Failed to load version'}
            </Text>
          ) : (
            <Flex direction="column" gap="md">
              <Flex align="center" gap="md">
                <Text className="text-muted-foreground min-w-[100px]">Version:</Text>
                <Text weight="medium" className="font-mono text-lg">
                  v{versionQuery.data?.version ?? 'unknown'}
                </Text>
              </Flex>
            </Flex>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
